module.exports = __webpack_public_path__ + "img/ms-line-long.48d8949b.svg";